export default __webpack_public_path__ + "static/media/ccc-care.bb04558d.png";